export const LANGUAGE = {
  en: 'en',
  de: 'de',
};

export const languageOptions = [
  {value: LANGUAGE.en, label: 'app.language.en'},
  {value: LANGUAGE.de, label: 'app.language.de'},
];

export default LANGUAGE;
